import React from 'react';

export default ({ children }) => <span className="badge">{children}</span>;
